import { chipOrder, limitChip } from './format.js'
import type { LimitStatus, SiteUnits } from './types.js'

interface Props {
  limits: LimitStatus[]
  units: SiteUnits
  timeZone: string
}

/**
 * The owner's limits as bare coloured dots, a row of their own directly above the wind direction in the
 * left wind reading (Kyle, 2026-10-02: "little colored dots above the text that displays the wind direction
 * in degrees"; "move the ... dot to the left wind reading ... remove all accompanying text"). Red past, amber approaching, green within; hollow when there is no reading yet or
 * the feed has gone quiet, so a dot never looks live when it is not. The words stay for screen readers
 * only, in the dot's accessible label.
 */
export function LimitDots({ limits, units, timeZone }: Props) {
  if (limits.length === 0) return null
  const chips = limits.map((s) => ({ s, chip: limitChip(s, units, timeZone) })).sort((a, b) => chipOrder(a.chip) - chipOrder(b.chip))
  return (
    <ul className="wind-dots" aria-label="Your limits">
      {chips.map(({ s, chip }) => (
        <li key={s.rule.ruleId} className={`wind-dot wind-dot--${chip.tone}`} aria-label={`${chip.setName}: ${chip.text}`} />
      ))}
    </ul>
  )
}
